import PetGeneralInfo from "./PetGeneralInfo";

export default PetGeneralInfo;
